import React, { useEffect } from "react";
import icons from "../../assets/images/sprite-other-icons.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsconfirm,
  setIsmodalOpen,
  setShowRedeemPopUp,
} from "../home/cl_LoyalltyCoins";
import { useState } from "react";
import congrasMsg from "../../assets/images//loyalty/congrats.svg";
import { redeemCoins, setBurnCoinsData } from "../signIn/cl_SignInSlice";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import { endpoints } from "../../api/ApiEndPoints";
export const RedeemModal = ({ coins, setBurnCoins }) => {
  const { userDetails, errorMessage, burnCoins, isApiCall } = useSelector(
    (state) => state?.signIn
  );

  const token = getFromLocalStorage("gk");
  const phoneNumber = userDetails?.userOtherInfo?.phone;
  const currency = userDetails?.userOtherInfo?.currency;
  const dispatch = useDispatch();
  const bonus_type = "loyalty_burn";
  const coinsValue = coins;
  const confirmRedeem = () => {
    const dynamicSecretKey = endpoints?.hashMap; 

    if (!dynamicSecretKey) {
      console.error("Secret key not available at redeem time");
      return;
    }

    if (errorMessage) {
      return;
    }

    if (!isApiCall && !burnCoins?.amount) {
      dispatch(
        redeemCoins(
          userDetails?.userId,
          coins,
          token,
          phoneNumber,
          currency,
          bonus_type,
          coinsValue,
          burnCoins?.result?.amount
        )
      );
    }
  };

  return (
    <div
      className="SB-modal SB-burnNowCoins-modal SB-modal-fullscreen open"
      id="SB-burnNowCoins-modal"
    >
      <div className="SB-modal-dialog">
        <div className="SB-modal-content">
          <div
            className="SB-modal-close"
            data-dismiss="modal"
            onClick={() => {
              if (burnCoins?.result?.amount) {
                setBurnCoins("");
              } else {
                setBurnCoins(coins);
              }
              dispatch(setBurnCoinsData([]));
              dispatch(setIsmodalOpen(false));
              dispatch(setShowRedeemPopUp(false));
            }}
          >
            <div className="SB-iconSVG" title="close">
              <svg xmlns="http://www.w3.org/2000/svg">
                <use xlinkHref={`${icons}#${"icon-close"}`} />
              </svg>
            </div>
          </div>
          <div className="SB-modal-body">
            {burnCoins?.result?.amount ? (
              <div className="SB-burnCoins-success" id="SB-burnCoins-success">
                <img src={congrasMsg} alt="congrats" />
                <div className="SB-confetti">
                  <div className="SB-confetti-Before"></div>
                </div>
                <div className="SB-modal-header">
                  <div className="SB-modal-title">Congratulations!</div>
                </div>
                <p>Your account has been credited with</p>
                <div className="SB-instantCashBack">
                  <div className="SB-instantCashBack-value">
                    <sup>KES</sup>
                    {burnCoins?.result?.amount
                      ? Number?.isInteger(burnCoins?.result?.amount)
                        ? burnCoins?.result?.amount.toString()
                        : burnCoins?.result?.amount?.toFixed(2)
                      : 0}
                  </div>
                  <div className="SB-instantCashBack-label">
                    Instant Cashback
                  </div>
                </div>
              </div>
            ) : (
              <div id="SB-burnCoins-confirmation">
                <div className="SB-modal-header">
                  <div className="SB-modal-title">
                    Redeem <span className="SB-burnCoins-count">{coins}</span>{" "}
                    FasFas Coins?
                  </div>
                </div>
                <p>
                  You will get Instant Cashback credited to your wallet
                  immediately
                </p>
                <div className="SB-btnContainer">
                  <button
                    className="btn active SB-btnSecondary SB-btnCancelOutline"
                    onClick={() => {
                      dispatch(setShowRedeemPopUp(false));
                      dispatch(setIsmodalOpen(false));
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn active SB-btnSecondary SB-confirm"
                    id="SB-confirm-cashBackBtn"
                    onClick={confirmRedeem}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
